import { register } from '../../../JavaScript/Utils'

const AutoSubmitFilters = el => {
  const form = el.closest('form')

  if (form) {
    const formElements = el.querySelectorAll('select, input')
    formElements.forEach(formElement => formElement.addEventListener('change', () => form.submit()))
  }
}

register('AutoSubmitFilters', AutoSubmitFilters)
